import { useRecordContext } from 'ra-core'
import { CustomerCard } from '@/components/app/CustomerCard'
import type { CustomerCardPerson } from '@/components/app/CustomerCard'
import { SubscriptionsTab } from './SubscriptionsTab'

/**
 * The combined page's "Profile" tab (default tab, HATCH-101 round 4 — ticket
 * feedback: split the page into per-tab URLs with profile first, so the
 * page-level Edit button — which edits exactly these scalar fields, see
 * `index.tsx`'s `UserEditPage` — has an unambiguous "what am I editing"
 * context, instead of sitting above every tab. HATCH-274: the flat field
 * grid is now the shared, readonly `CustomerCard` — `linkToProfile={false}`
 * since we're already on that profile; editing still goes through the
 * page-level `EditButton`/`UserEditPage`, not this card.
 *
 * Subscription cards (this ticket) live here too, not on their own tab —
 * round 5 review: "In user profile, can we move subscription card directly
 * to the same tab with profile itself."
 */
export function ProfileTab() {
  const record = useRecordContext()
  if (!record) return null

  return (
    <div className="flex flex-col gap-6">
      <CustomerCard customer={record as CustomerCardPerson} linkToProfile={false} />
      <div className="flex flex-col gap-2">
        <h3 className="text-lg font-semibold">Subscriptions</h3>
        <SubscriptionsTab email={record.email} />
      </div>
    </div>
  )
}
